import angular from 'angular';


ToastrConfig.$inject = ['toastrConfig'];

function ToastrConfig(toastrConfig) {
    angular.extend(toastrConfig, {
        newestOnTop: false,
        positionClass: 'toast-bottom-right',
    });
}

export default ToastrConfig